<template>
  <div class="text-right visit-pay-totals bg-body">
    <div class="price-table ml-auto">
      <DottedRow :label="$t('total')"
                 :value="formatCurrency(visitCostServicesWithoutDiscount, true, true)"/>
      <DottedRow :label="$t('discount')"
                 v-if="paymentFor === 'visit'"
                 :value="formatCurrency(discount, true, true)"/>
      <DottedRow :label="$t('additional_discount')"
                 v-if="showAdditionalDiscount"
                 :value="formatCurrency(additionalDiscount, true, true)"/>
      <DottedRow class="total"
                 :label="$t('total_to_pay')"
                 :value="formatCurrency(finalAmount, true, true)"/>

      <div>

        <hr/>

        <DottedRow v-if="paidWithBonuses > 0"
                   :label="$t('paid_with_bonus')"
                   :value="formatCurrency(paidWithBonuses, true, true)"/>
        <DottedRow v-if="bonus > 0"
                   :label="$t('to_pay_with_bonus')"
                   :value="formatCurrency(bonus, true, true)"/>
        <DottedRow v-if="visit"
                   :label="$t('paid')"
                   :value="formatCurrency((visit.paidSum - paidWithBonuses), true, true)"/>
        <DottedRow :class="{'text-danger': leftToPay > 0 }"
                   :label="$t('debt')"
                   :value="formatCurrency(leftToPay, true, true)"/>

      </div>

    </div>
  </div>
</template>

<script setup>
import DottedRow from "@/components/parts/general/DottedRow.vue"
import {computed} from "vue"
import {useStore} from "vuex"
import {formatCurrency} from "@/extensions/filters/filters"

const store = useStore()

const props = defineProps({
  showAdditionalDiscount: {
    type: Boolean,
    default: true
  },
  leftToPay: {},
  paidWithBonuses: {},
  bonus: {},
  paymentFor: {
    type: String,
    default: 'visit'
  },
  costOfMaterialsForSale: {
    type: Number,
  },
  materialsDiscountAbsolute: {
    type: Number,
  }
})

const visit = computed(() => store.state.patient.visit)
const visitCostServicesWithoutDiscount = computed(() => {
  if(props.paymentFor === 'material') {
    return props.costOfMaterialsForSale
  }
  return store.getters.visitCostServicesWithoutDiscount
})
const visitCostServicesWithDiscount = computed(() => {
  if(props.paymentFor === 'material') {
    return visitCostServicesWithoutDiscount.value
  }
  return store.getters.visitCostServicesWithDiscount
})
const discount = computed(() => visitCostServicesWithoutDiscount.value - visitCostServicesWithDiscount.value)
const additionalDiscount = computed(() => {
  if(props.paymentFor === 'material') {
    return props.materialsDiscountAbsolute
  }
  return visit.value?.additional_discount || 0
})
const finalAmount = computed(() => visitCostServicesWithDiscount.value - additionalDiscount.value)
</script>

<style scoped lang="scss">
.visit-pay-totals {
  padding: 16px;
  border-radius: 12px;
}
</style>
